import Request from './RequestHandler.js'

export default {
  index (params) {
    return Request.make('get', 'offers', params)
  },
  show (id) {
    return Request.make('get', 'offers/' + id)
  },
  create (params) {
    return Request.make('post', 'offers', params)
  },
  patch (id, params) {
    return Request.make('patch', 'offers/' + id, params)
  },
  destroy (id) {
    return Request.make('delete', 'offers/' + id)
  },
  filter (params) {
    return Request.make('get', 'offers', params)
  }
}
